








helpers = require('../../helpers.coffee')

exports.default = {
  props:
    max_height:
      default: 200

  computed:
    max_height_style: ->
      "#{@max_height}px"
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/internal_scroller.vue